{
	"title": "Medewerkers",
	"description": "Wie in het beheer werkt. Iedereen die inlogt, mag alles.",
	"searchLabel": "Zoek op naam of e-mailadres",
	"empty": "Er zijn nog geen medewerkers.",
	"column": {
		"name": "Naam",
		"email": "E-mailadres",
		"status": "Status",
		"passkeys": "Passkeys",
		"lastLogin": "Laatst ingelogd",
		"created": "Toegevoegd"
	},
	"status": {
		"label": "Status",
		"invited": "Uitgenodigd",
		"active": "Actief",
		"deactivated": "Gedeactiveerd"
	},
	"new": {
		"title": "Medewerker uitnodigen",
		"description": "De nieuwe medewerker krijgt een mail met een link om een passkey te koppelen.",
		"submit": "Uitnodiging versturen"
	},
	"field": {
		"name": "Naam",
		"email": "E-mailadres",
		"emailDescription": "Hiermee herken je de medewerker. Inloggen gaat met een passkey, zonder wachtwoord."
	},
	"emailTaken": "Er is al een medewerker met dit e-mailadres.",
	"created": {
		"title": "{{name}} is uitgenodigd",
		"sent": "De uitnodiging is naar {{email}} gestuurd. De link werkt één keer, tot {{expiresAt}}.",
		"simulated": "Dit is geen productie: de uitnodiging staat in het maillog maar is niet echt verstuurd. Stuur de link zelf door; hij werkt één keer, tot {{expiresAt}}.",
		"failed": "De mail kon niet worden verstuurd. Stuur de link zelf naar {{name}}; hij werkt één keer, tot {{expiresAt}}.",
		"link": "Koppellink",
		"copy": "Kopiëren",
		"copied": "Gekopieerd",
		"another": "Nog iemand uitnodigen",
		"done": "Naar medewerkers"
	},
	"detail": {
		"facts": "Gegevens",
		"deactivatedAt": "Gedeactiveerd op",
		"open": "{{name}} openen",
		"password": "Wachtwoord",
		"passwordSet": "Ingesteld",
		"passwordNotSet": "Niet ingesteld"
	},
	"passkeys": {
		"title": "Passkeys",
		"description": "Waarmee deze medewerker inlogt, bijvoorbeeld op een laptop en een telefoon.",
		"lastOne": "Dit is de enige passkey en er is geen wachtwoord. Die kun je niet verwijderen: voeg eerst een andere manier van inloggen toe, of deactiveer de medewerker.",
		"none": "Nog geen passkey. De medewerker koppelt er een via de link uit de uitnodiging.",
		"name": "Passkey {{number}}",
		"synced": "Gesynchroniseerd tussen apparaten",
		"device": "Op één apparaat",
		"column": {
			"passkey": "Passkey",
			"created": "Toegevoegd",
			"lastUsed": "Laatst gebruikt",
			"actions": "Acties"
		},
		"add": "Passkey toevoegen op dit apparaat",
		"added": "De passkey is toegevoegd.",
		"remove": {
			"button": "{{name}} verwijderen",
			"title": "Passkey verwijderen?",
			"description": "{{name}} kan daarna niet meer inloggen met deze passkey. Sessies die ermee zijn gestart, stoppen meteen.",
			"descriptionSelf": "Je kunt daarna niet meer inloggen met deze passkey. Ben je er nu mee ingelogd, dan word je uitgelogd.",
			"confirm": "Verwijderen"
		},
		"deactivated": "De medewerker is gedeactiveerd: geen van deze passkeys werkt nog."
	},
	"invitation": {
		"titleInvited": "Uitnodiging",
		"titleActive": "Nieuwe koppellink",
		"descriptionInvited": "Nog geen passkey gekoppeld. Stuur een nieuwe uitnodiging als de vorige kwijt of verlopen is.",
		"descriptionActive": "Voor een nieuw apparaat: de medewerker krijgt een link om nog een passkey te koppelen.",
		"send": "Link mailen",
		"result": {
			"sent": "Verstuurd naar {{email}}. Eerdere links werken niet meer.",
			"simulated": "Dit is geen productie: de mail staat in het maillog maar is niet echt verstuurd. Eerdere links werken niet meer.",
			"failed": "De mail kon niet worden verstuurd. Probeer het later opnieuw."
		}
	},
	"deactivate": {
		"title": "Deactiveren",
		"description": "De medewerker kan daarna niet meer inloggen. Lopende sessies stoppen en persoonlijke tokens worden ingetrokken.",
		"button": "Medewerker deactiveren",
		"confirmTitle": "{{name}} deactiveren?",
		"confirmDescription": "{{name}} wordt meteen overal uitgelogd en kan niet meer inloggen. Persoonlijke tokens worden ingetrokken; ook als je {{name}} later weer activeert, werken die niet meer.",
		"confirm": "Deactiveren",
		"self": "Je kunt jezelf niet deactiveren."
	},
	"reactivate": {
		"title": "Weer activeren",
		"description": "De medewerker kan daarna weer inloggen. Oude sessies en tokens blijven ingetrokken.",
		"button": "Medewerker weer activeren",
		"confirmTitle": "{{name}} weer activeren?",
		"confirmWithPasskeys_one": "{{name}} kan daarna weer inloggen met de passkey die er nog is. Oude sessies en persoonlijke tokens blijven ingetrokken.",
		"confirmWithPasskeys_other": "{{name}} kan daarna weer inloggen met de {{count}} passkeys die er nog zijn. Oude sessies en persoonlijke tokens blijven ingetrokken.",
		"confirmWithoutPasskeys": "{{name}} heeft geen passkey meer. Stuur daarna een nieuwe koppellink, zodat {{name}} er een kan koppelen.",
		"confirm": "Weer activeren"
	},
	"help": {
		"employees": {
			"title": "Medewerker",
			"area": "Instellingen › Medewerkers",
			"short": "Iedereen die in het beheer werkt. Elke medewerker heeft een eigen account, kiest zelf hoe die inlogt, en mag alles. Een nieuwe medewerker krijgt een koppellink om de eerste inlog in te stellen.",
			"terms": ["employee:enrolmentLink", "employee:status", "employee:signIn"]
		},
		"status": {
			"title": "Status van een medewerker",
			"area": "Instellingen › Medewerkers",
			"short": "Of een medewerker kan inloggen.",
			"choices": [
				{
					"name": "Uitgenodigd",
					"text": "Heeft nog geen passkey of wachtwoord: de koppellink is nog niet gebruikt."
				},
				{
					"name": "Actief",
					"text": "Kan inloggen."
				},
				{
					"name": "Gedeactiveerd",
					"text": "Kan niet meer inloggen. Sessies en tokens zijn ingetrokken."
				}
			],
			"terms": ["employee:enrolmentLink", "employee:deactivate"]
		},
		"new": {
			"title": "Medewerker uitnodigen",
			"area": "Instellingen › Medewerkers",
			"short": "Vul naam en e-mailadres in. De medewerker krijgt een mail met een koppellink. Je ziet de link hier ook, om zelf door te sturen als de mail niet aankomt.",
			"terms": ["employee:enrolmentLink"]
		},
		"enrolmentLink": {
			"title": "Koppellink",
			"area": "Instellingen › Medewerkers",
			"short": "Een link die één keer werkt, 24 uur lang. Daarmee koppelt een medewerker een passkey of stelt een wachtwoord in. Mail je een nieuwe, dan werken eerdere links niet meer.",
			"warning": "Buiten productie gaat er geen mail echt weg: kopieer de link en stuur hem zelf door.",
			"terms": ["employee:passkeys", "employee:signIn"]
		},
		"employee": {
			"title": "Een medewerker",
			"area": "Instellingen › Medewerkers",
			"short": "Hoe deze medewerker inlogt en wanneer voor het laatst. Hier mail je een nieuwe koppellink, verwijder je een passkey of deactiveer je de medewerker.",
			"terms": ["employee:signIn", "employee:enrolmentLink", "employee:passkeys", "employee:deactivate"]
		},
		"signIn": {
			"title": "Inloggen",
			"area": "Instellingen › Medewerkers",
			"short": "Met een passkey, of met wachtwoord en een code uit de mail. In een vertrouwde browser is die code 30 dagen niet nodig. Elke browser waarin iemand is ingelogd, is een sessie.",
			"terms": ["employee:passkeys", "session:trustedBrowser", "employee:session"]
		},
		"session": {
			"title": "Sessie",
			"area": "Instellingen › Medewerkers",
			"short": "Een browser waarin een medewerker is ingelogd. Hij loopt af na 7 dagen zonder gebruik, en altijd na 30 dagen. Uitloggen of deactiveren stopt hem meteen.",
			"terms": ["employee:deactivate"]
		},
		"passkeys": {
			"title": "Passkey",
			"area": "Instellingen › Medewerkers",
			"short": "Inloggen met de vingerafdruk, het gezicht of de pincode van je apparaat. Een medewerker kan er meer hebben, zoals op laptop en telefoon. Een nieuwe komt via een koppellink, of je voegt er zelf een toe.",
			"warning": "De laatste manier van inloggen blijft: de enige passkey verwijder je pas als er een wachtwoord is. Sessies die met een verwijderde passkey zijn gestart, stoppen meteen.",
			"terms": ["employee:enrolmentLink", "employee:session"]
		},
		"deactivate": {
			"title": "Deactiveren",
			"area": "Instellingen › Medewerkers",
			"short": "De medewerker kan niet meer inloggen. Elke sessie stopt meteen en de persoonlijke tokens worden ingetrokken. Passkeys en historie blijven bewaard.",
			"warning": "Weer activeren kan, maar oude sessies en tokens blijven ingetrokken. Jezelf deactiveren kan niet.",
			"terms": ["employee:session", "personalAccessToken:tokens"]
		}
	}
}
